export const checkWebUSB = () => { //Check if port exist
    return 'usb' in navigator;
}

export const savePrinterUSB = (device) => { //Save port selected in localstorage
    const printerData = {
        vendorId: device.vendorId,
        productId: device.productId,
    };
    localStorage.setItem('selectedPrinter', JSON.stringify(printerData));
}

export const listUSBDevices = async(save = true) => { //List USB devices and save the selected device
    const check = checkWebUSB();
    
    if(check){
        try {
            const device = await navigator.usb.requestDevice({ filters: [] });
            if(save){
                savePrinterUSB(device);
                return {
                    error: false,
                    device: device
                };
            }
            
        } catch (error) {
            return {
                error: true,
                message: 'Error listing USB devices: ' + error.message
            };
        }
    }else{
        return {
            error: true,
            message: 'Este navegador no soporta la impresion web.'
        };
    }
    
}

export const printUSB = async (data) => { //Send to print to the selected device

    const selectedPrinter = await loadPrinter();
    
    if (!selectedPrinter) {
        console.error('No hay dispositivo seleccionado.');
        return false;
    }


    const formattedTicket = formatTicket(data);

    try {
        await selectedPrinter.open();
        await selectedPrinter.selectConfiguration(1);
        await selectedPrinter.claimInterface(0);

        const commands = new Uint8Array([
            0x1b, 0x40, // Initialize printer
            0x1b, 0x61, 0x00, // Align left
            ...new TextEncoder().encode(formattedTicket),
            0x0a, 0x0a, 0x0a, // Line feed
            0x1d, 0x56, 0x41, 0, // Cut paper
        ]);

        await selectedPrinter.transferOut(1, commands);
        console.log('Pagina de prueba enviada exitosamente');
        return true;
    } catch (error) {
        console.log('Ocurrió un error al imprimir: ',error.message);
        return false;
    }
}

export const formatTicket = (data) => { //Adjust the data to be printed on the invoice
    const line = '-'.repeat(45) + '\n';
    const maxWidth = 45;
    let ticket = '';

    // Centered header
    const header = [
        data.business || '',
        data.nit_business || data.nit,
        data.city_point || 'Ciudad: No definida',
        data.phone_point || 'Teléfono: No definido',
        data.address_point || 'Dirección: No definida',
        //data.resolution || 'Resolución: No definida',
        //`Documento: ${data.document_number}`
    ].join('\n');

    ticket += centerText(header, maxWidth) + '\n';
    ticket += line;

    const invoiceDetails = [
        //`Factura Electrónica de Venta: ${data.invoice_number || ''}`,
        `Estado de Cuenta: ${data.document_number}`,
        `Fecha: ${data.document_date}`,
        `Vendedor: ${data.vendedor}`,
        `Nombre: ${data.client_name}`,
        `Cedula/Nit: ${data.client_identification}`,
        `Telefono: ${data.client_phone}`,
        //`Dirección: ${data.client_address}`,
    ];

    invoiceDetails.forEach(detailLine => {
        ticket += `${detailLine}\n`;
    });

    ticket += line;

    // Products (fixed column format)
    ticket += 'Descripcion               Cant       Valor\n';
    /*data.details.forEach(item => {
      const description = item.product_invoice.substring(0, 20).padEnd(20);
      const quantity = item.quantity.toString().padStart(10);
      const price = item.value.padStart(15);
      ticket += `${description}${quantity}${price}\n`;
    });*/

    data.details.forEach(item => {
        const description = item.product_invoice;
        const quantity = item.quantity.toString().padStart(5);
        const price = item.value.padStart(10);

        // Manejo de múltiples líneas para la descripción
        const maxDescWidth = 20; // Ancho máximo para la descripción
        const descriptionLines = wrapText(description, maxDescWidth); // Función para dividir el texto en líneas

        descriptionLines.forEach((line, index) => {
            if (index === 0) { // Primera línea
                ticket += `${line.padEnd(maxDescWidth)}\t${quantity}\t${price}\n`;
            } else { // Líneas siguientes (con espacios en blanco para las columnas Cant y Valor)
                ticket += `${line.padEnd(maxDescWidth)}\t\t\n`;
            }
        });
    });

    ticket += '\nObservaciones\n';
    ticket += `${data.commentary}\n`;
    ticket += line;

    // Totals aligned to the right
    const totals = [
        `Subtotal sin Imp: ${data.subtotal_without_imp}`,
        `Imp. Consumo: ${data.impuesto_consumo}`,
        `Subtotal: ${data.subtotal}`,
        `Propina: ${data.service}`,
        `Domicilio: ${data.shipping}`,
        `Descuento: ${data.total_discount}`,
        `Total: ${data.total}`,
        `Forma de pago: ${data.payment_methods}`,
    ];

    totals.forEach(totalLine => {
      ticket += totalLine.padStart(maxWidth) + '\n';
    });

    ticket += line;

    // Footer
    const footer = [
        'Qr para descargar su factura.',
        //`${data.qr_fac}`,
        //`Cufe: ${data.cufe}`,
        '',
        'Gracias por su compra!',
        'Impreso por VinApp'
    ];

    const centeredFooter = centerText(footer.join('\n'), maxWidth);
    ticket += centeredFooter;

    return ticket;
}

const wrapText = (text, maxWidth) => {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';

    for (const word of words) {
        if (currentLine.length + word.length + 1 <= maxWidth) {
            currentLine += (currentLine ? ' ' : '') + word;
        } else {
            lines.push(currentLine);
            currentLine = word;
        }
    }

    lines.push(currentLine); // Agregar la última línea
    return lines;
};

export const centerText = (text, width) => { //Center the data to be printed on the invoice
    const lines = text.split('\n');
    return lines.map(line =>
      line
        .padStart(line.length + Math.floor((width - line.length) / 2), ' ')
        .padEnd(width, ' ')
    ).join('\n');
}

export const loadPrinter = async () => {
    const printerData = localStorage.getItem('selectedPrinter');
    if (printerData) {
        const { vendorId, productId } = JSON.parse(printerData);

        try {
            const devices = await navigator.usb.getDevices();
            const matchedDevice = devices.find(
            (device) =>
                device.vendorId === vendorId && device.productId === productId
            );

            if (matchedDevice) {
                console.log('Impresora encontrada');
                return matchedDevice;
            } else {
                console.log('Impresora no encontrada');
                return null;
            }
        } catch (error) {
            console.log('Error cargando impresora: ', error.message);
            return null;
        }
    } else {
      console.log('No printer loaded');
      return null;
    }
}